import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

export const Title = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      gap={isDesktop ? '16px' : '8px'}
      maxWidth={isDesktop ? 'initial' : '270px'}
    >
      <Typography variant={'h2'} color={'text.secondary'} component='h1'>
        {Dictionary[DICTIONARY.MedicalReferrals].title}
      </Typography>
      <Typography variant={'body3'} color={'text.secondary'}>
        {Dictionary[DICTIONARY.MedicalReferrals].titleInfo}
      </Typography>
    </Stack>
  );
};
